// Typed-input draft shape for the T8 dropset chain, shared by the
// mobile Logger (apps/mobile/src/state/loggerDraft.ts) and the web
// Logger (apps/web/src/workout/WorkoutLog.tsx). This is the
// *string-based form draft* — distinct from the canonical Dropset
// schema in ./schemas/{workout,logSet}.ts. Each Logger's buildPayload
// parses these strings into the canonical Dropset at save time.
//
// Two variants in the order Antenore uses on web: classical (drop the
// weight, chase fatigue) vs. myorep (same load, micro-rest, repeat).
// `weight` is a single string field for both weighted and bodyweight
// parents; each Logger renders the placeholder differently based on
// the parent kind. For myorep the value typically stays empty
// (= same load as the parent set).
export type DropsetVariant = 'classical' | 'myorep';

export interface DropsetStepDraft {
  reps: string;
  weight: string;
  /** Per-step completion pill (mobile Logger redesign slice 4). Mirrors
   *  the canonical DropsetStep.completedAt. null/absent = pending; ISO
   *  timestamp when the step pill cycles to done. Optional because the
   *  web Logger has no per-step pills — its step drafts stay
   *  {reps, weight} and never set or read this. buildPayload (mobile)
   *  stamps the value onto the saved DropsetStep. */
  completedAt?: string | null;
}

export interface DropsetDraft {
  variant: DropsetVariant;
  steps: DropsetStepDraft[];
}

export const MAX_DROPSET_STEPS = 8;

export const blankDropsetStep = (): DropsetStepDraft => ({
  reps: '',
  weight: '',
  completedAt: null,
});

export const blankDropset = (
  variant: DropsetVariant = 'classical',
): DropsetDraft => ({
  variant,
  steps: [blankDropsetStep()],
});
